import {useEffect} from 'react'
import {Link, Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'
import AiCoachWidget from 'app/modules/ai/components/AiCoachWidget'
import AiCoachDrawer from 'app/modules/ai/components/AiCoachDrawer'
import {AiCoachProvider} from 'app/modules/ai/core/AiCoachContext'
import {rememberDeskEmbed} from 'app/modules/auth/core/AuthHelpers'

const DESK_NAV = [
  {to: '/performance', title: 'Performance'},
  {to: '/setup/overview', title: 'Setups'},
  {to: '/setup/add-setup', title: 'Create Setup'},
  {to: '/ai-coach', title: 'AI Coach'},
  {to: '/referral', title: 'Social'},
]

function EmbedNav() {
  const {pathname} = useLocation()
  return (
    <nav
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        padding: '8px 16px',
        position: 'sticky',
        top: 0,
        zIndex: 20,
        background: 'var(--body-bg, #0d1117)',
        borderBottom: '1px solid var(--border-color, rgba(255,255,255,0.08))',
      }}
    >
      {DESK_NAV.map((item) => {
        const active = pathname === item.to || pathname.startsWith(`${item.to}/`)
        return (
          <Link
            key={item.to}
            to={item.to}
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: active ? 600 : 500,
              color: active ? 'var(--text-primary)' : 'var(--text-muted)',
              background: active ? 'rgba(232, 64, 64, 0.12)' : 'transparent',
            }}
          >
            {item.title}
          </Link>
        )
      })}
    </nav>
  )
}

const MasterLayout = () => {
  const location = useLocation()
  const embedded = rememberDeskEmbed()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <AiCoachProvider>
        <div className='d-flex flex-column flex-root'>
          {embedded ? (
            <div className='d-flex flex-column flex-column-fluid'>
              <EmbedNav />
              <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
          ) : (
            <div className='page d-flex flex-row flex-column-fluid'>
              <AsideDefault />
              <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                <HeaderWrapper />

                <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                <Footer />
              </div>
            </div>
          )}
          <AiCoachWidget />
          <AiCoachDrawer />
        </div>
      </AiCoachProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
